import { render } from "./GrModalSmall.vue?vue&type=template&id=5e5790fc&scoped=true"
import script from "./GrModalSmall.vue?vue&type=script&lang=js"
export * from "./GrModalSmall.vue?vue&type=script&lang=js"

import "./GrModalSmall.vue?vue&type=style&index=0&id=5e5790fc&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5790fc"]])

export default __exports__